(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-asignacion', {
            parent: 'entity',
            url: '/ss-asignacion?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSAsignacions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-asignacion/s-s-asignacions.html',
                    controller: 'SSAsignacionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
        .state('ss-asignacion-detail', {
            parent: 'ss-asignacion',
            url: '/ss-asignacion/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSAsignacion'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-asignacion/ss-asignacion-detail.html',
                    controller: 'SSAsignacionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSAsignacion', function($stateParams, SSAsignacion) {
                    return SSAsignacion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-asignacion',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-asignacion-detail.edit', {
            parent: 'ss-asignacion-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-asignacion/ss-asignacion-dialog.html',
                    controller: 'SSAsignacionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-asignacion.new', {
            parent: 'ss-asignacion',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-asignacion/ss-asignacion-dialog.html',
                    controller: 'SSAsignacionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                iniPrestacion: null,
                                finPrestacion: null,
                                duracionHoras: null,
                                estatusPrestador: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                expediente: null,
                                fechaLiberacion: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-asignacion', null, { reload: 'ss-asignacion' });
                }, function() {
                    $state.go('ss-asignacion');
                });
            }]
        })
        .state('ss-asignacion.edit', {
            parent: 'ss-asignacion',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-asignacion/ss-asignacion-dialog.html',
                    controller: 'SSAsignacionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-asignacion', null, { reload: 'ss-asignacion' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-asignacion.delete', {
            parent: 'ss-asignacion',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-asignacion/ss-asignacion-delete-dialog.html',
                    controller: 'SSAsignacionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSAsignacion', function(SSAsignacion) {
                            return SSAsignacion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-asignacion', null, { reload: 'ss-asignacion' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
